import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <svg
        width="90%"
        height="90%"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12.7 12.7"
      >
        <g transform="translate(-8.94 -22.87)">
          <rect
            ry={1.3}
            rx={1.3}
            y={22.871}
            x={8.941}
            height={12.7}
            width={12.7}
            fill="#017d87"
          />
          <path
            d="M13.566 24.449V27H12.22v1.536h1.323v3.874c.16.815.847 1.318 1.464 1.464 1.346.161 1.972-.046 2.8-.295l-.414-1.453c-.602.193-1.528.57-1.96 0v-3.543h1.937l.472-1.607h-2.48v-2.504z"
            fill="#fff"
          />
        </g>
      </svg>
    </>
  ),
  'Talis',
  '0 0 12.7 12.7'
);
